<template>
  <WsUpdate
    :modelName="modelName"
    :id="$route.params.id"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    editType="duplicateVersion"
    titleKey="last_version.name"
  >
  </WsUpdate>
</template>

<script>
import model from "@/models/audit_template";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              fields: ["last_version"],
            },
          ],
        },
      ],
    },
  }),
};
</script>